import { render, staticRenderFns } from "./FileHandler.vue?vue&type=template&id=37d7898d"
import script from "./FileHandler.vue?vue&type=script&lang=js"
export * from "./FileHandler.vue?vue&type=script&lang=js"
import style0 from "./FileHandler.vue?vue&type=style&index=0&id=37d7898d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports